module.exports = __webpack_public_path__ + "img/skating_2018_002.19996fab.jpg";